const STATUS_COLORS = Object.freeze({
	dark: {
		info: '#75adff',
		warning: '#f4b44d',
		danger: '#ff7a88',
		infoSubtle: 'rgba(117, 173, 255, 0.16)',
		warningSubtle: 'rgba(244, 180, 77, 0.16)',
		dangerSubtle: 'rgba(255, 122, 136, 0.16)',
	},
	light: {
		info: '#185faa',
		warning: '#875400',
		danger: '#b4233a',
		infoSubtle: 'rgba(24, 95, 170, 0.1)',
		warningSubtle: 'rgba(135, 84, 0, 0.1)',
		dangerSubtle: 'rgba(180, 35, 58, 0.1)',
	},
});

export const getImportReviewThemeTokens = (theme, isDarkTheme) => {
	const status = STATUS_COLORS[isDarkTheme ? 'dark' : 'light'];

	return {
		background: theme._primaryBackgroundColor,
		surface: theme._secondaryBackgroundColor,
		surfaceRaised: theme._surfaceBackgroundColor,
		text: theme._highEmphasisColor,
		textSecondary: theme._mediumEmphasisColor,
		textMuted: theme._inactiveColor,
		border: theme._surfaceBackgroundColor,
		borderStrong: theme._inactiveColor,
		accent: theme._secondaryColor,
		disabledSurface: theme._disabledBackgroundColor,
		focus: isDarkTheme ? status.info : '#246fdd',
		action: '#246fdd',
		actionHover: '#1d5fc4',
		actionText: '#ffffff',
		actionSubtle: isDarkTheme
			? 'rgba(36, 111, 221, 0.2)'
			: 'rgba(36, 111, 221, 0.1)',
		actionSubtleHover: isDarkTheme
			? 'rgba(36, 111, 221, 0.28)'
			: 'rgba(36, 111, 221, 0.16)',
		success: theme._secondaryColor,
		successSubtle: isDarkTheme
			? 'rgba(30, 185, 128, 0.14)'
			: 'rgba(0, 122, 70, 0.09)',
		...status,
	};
};

export const getImportReviewThemeStyle = (theme, isDarkTheme) => {
	const tokens = getImportReviewThemeTokens(theme, isDarkTheme);

	return {
		'--import-review-background': tokens.background,
		'--import-review-surface': tokens.surface,
		'--import-review-surface-raised': tokens.surfaceRaised,
		'--import-review-text': tokens.text,
		'--import-review-text-secondary': tokens.textSecondary,
		'--import-review-text-muted': tokens.textMuted,
		'--import-review-border': tokens.border,
		'--import-review-border-strong': tokens.borderStrong,
		'--import-review-accent': tokens.accent,
		'--import-review-disabled-surface': tokens.disabledSurface,
		'--import-review-focus': tokens.focus,
		'--import-review-action': tokens.action,
		'--import-review-action-hover': tokens.actionHover,
		'--import-review-action-text': tokens.actionText,
		'--import-review-action-subtle': tokens.actionSubtle,
		'--import-review-action-subtle-hover': tokens.actionSubtleHover,
		'--import-review-success': tokens.success,
		'--import-review-success-subtle': tokens.successSubtle,
		'--import-review-info': tokens.info,
		'--import-review-info-subtle': tokens.infoSubtle,
		'--import-review-warning': tokens.warning,
		'--import-review-warning-subtle': tokens.warningSubtle,
		'--import-review-danger': tokens.danger,
		'--import-review-danger-subtle': tokens.dangerSubtle,
	};
};
